import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type ISummaryStyleClasses =
  | 'root'
  | 'containerTitle'
  | 'image'
  | 'newLink'
  | 'expandIcon'
  | 'tradeInCar'
  | 'expanded'
  | 'urlItem'
  | 'summaryContainer'
  | 'changeAction'
  | 'selectedFeaturesCategoryTitle'
  | 'selectedFeaturesSubcategoryTitle'
  | 'sectionTitle'
  | 'selectedOptionTitlePrice'
  | 'selectionContainer'
  | 'selectedOptionLabels';

const summaryStyles = makeStyles<ISpcTheme, ISummaryStyleClasses>(
  theme => ({
    changeAction: {},
    summaryContainer: {},
    root: {
      borderRadius: '3px',
      fontFamily: theme.typography.fontFamily,

      [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        borderRadius: 0,
        padding: '16px',
        border: `1px solid ${theme.palette.text.disabled}`,
      },
    },
    containerTitle: {
      minHeight: '56px',

      [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        minHeight: 'unset',
      },
    },
    expanded: {
      borderTop: 0,
    },
    image: {
      width: '100%',
    },
    expandIcon: {
      fontSize: theme.typography.fontXL,
      marginBottom: theme.spacing(-1),
    },
    tradeInCar: {
      position: 'relative',
      top: theme.spacing(-1.2),
    },
    newLink: {
      color: theme.palette.secondary.main,
      textDecoration: 'underline',
    },
    urlItem: {
      marginTop: theme.spacing(2),
    },
    selectedFeaturesCategoryTitle: {},
    sectionTitle: {},
    selectedOptionTitlePrice: {},
    selectedFeaturesSubcategoryTitle: {},
    selectionContainer: {},
    selectedOptionLabels: {},
  }),
  { name: 'Customise_Summary' },
);

export default summaryStyles;
